import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const RadiologyAndMedicalImagingIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M80.3569 40C80.3569 61.8153 62.6722 79.5 40.8569 79.5C19.0417 79.5 1.35693 61.8153 1.35693 40C1.35693 18.1848 19.0417 0.5 40.8569 0.5C62.6722 0.5 80.3569 18.1848 80.3569 40Z'
      />
      <g clipPath='url(#clip0_414_9518)'>
        <path d='M33.2412 43.5518H40.1378V58.2069H33.2412V43.5518Z' fill='#00B4D8' />
        <path
          d='M35.1205 54.7414C35.2955 55.2477 35.6234 55.6872 36.0588 55.9991C36.4943 56.311 37.0159 56.48 37.5516 56.4828H40.1378V58.2069H33.2412V43.5518H40.1378V51.6293C38.7412 53.5345 36.9998 54.6811 35.1205 54.7414Z'
          fill='#0096C7'
        />
        <path
          d='M24.6207 22.8621C19.8595 22.8621 16 29.8095 16 38.3793C16 46.9491 19.8595 53.8965 24.6207 53.8965H34.9655V22.8621H24.6207Z'
          fill='#B8BEBF'
        />
        <path
          d='M34.9655 45.276V53.8967H24.6207C19.8621 53.8967 16 46.9484 16 38.3794C16 31.5518 18.4569 25.7501 21.8621 23.6812C21.3956 25.6731 21.1641 27.7129 21.1724 29.7587C21.1724 38.3277 25.0345 45.276 29.7931 45.276H34.9655Z'
          fill='#93999A'
        />
        <path
          d='M34.9654 53.8965C39.7265 53.8965 43.5861 46.9492 43.5861 38.3793C43.5861 29.8094 39.7265 22.8621 34.9654 22.8621C30.2043 22.8621 26.3447 29.8094 26.3447 38.3793C26.3447 46.9492 30.2043 53.8965 34.9654 53.8965Z'
          fill='#E9F1F2'
        />
        <path
          d='M39.974 50.9999C38.5689 52.8189 36.8361 53.8965 34.9654 53.8965C30.2068 53.8965 26.3447 46.9482 26.3447 38.3793C26.3447 31.9051 28.5516 26.3534 31.6809 24.0344C29.4913 26.8534 28.0689 31.4568 28.0689 36.6551C28.0689 45.2241 31.9309 52.1724 36.6896 52.1724C37.8835 52.1532 39.0379 51.7412 39.974 50.9999Z'
          fill='#D0D8DA'
        />
        <path
          d='M34.9654 50.4482C37.822 50.4482 40.1378 45.0448 40.1378 38.3793C40.1378 31.7138 37.822 26.3103 34.9654 26.3103C32.1087 26.3103 29.793 31.7138 29.793 38.3793C29.793 45.0448 32.1087 50.4482 34.9654 50.4482Z'
          fill='#B8BEBF'
        />
        <path
          d='M39.2214 40.1033C38.9996 40.1016 38.7802 40.0561 38.576 39.9693C38.3718 39.8825 38.1868 39.7562 38.0316 39.5977C37.8764 39.4391 37.7541 39.2514 37.6717 39.0454C37.5893 38.8394 37.5485 38.6191 37.5516 38.3973V38.3792C37.5516 32.5378 35.5335 28.2844 33.6723 26.8464C31.8111 28.2844 29.793 32.5378 29.793 38.3792C29.793 45.6344 32.9059 50.4482 34.9654 50.4482C36.8559 50.4482 39.6283 46.3835 40.0706 40.1033H39.2214Z'
          fill='#93999A'
        />
        <path
          d='M22.0347 34.0689C22.9869 34.0689 23.7588 33.297 23.7588 32.3447C23.7588 31.3925 22.9869 30.6206 22.0347 30.6206C21.0825 30.6206 20.3105 31.3925 20.3105 32.3447C20.3105 33.297 21.0825 34.0689 22.0347 34.0689Z'
          fill='#FF7373'
        />
        <path
          d='M21.5003 33.9827C21.1831 33.8782 20.9031 33.6839 20.6942 33.4233C20.4854 33.1627 20.3567 32.847 20.3238 32.5147C20.2909 32.1824 20.3553 31.8476 20.5091 31.5512C20.6628 31.2547 20.8994 31.0093 21.19 30.8447C21.2302 31.896 21.3338 32.9439 21.5003 33.9827Z'
          fill='#EF5350'
        />
        <path
          d='M22.8968 42.6897H19.4485C19.2199 42.6897 19.0006 42.5989 18.8389 42.4372C18.6773 42.2756 18.5864 42.0563 18.5864 41.8276C18.5864 41.599 18.6773 41.3797 18.8389 41.2181C19.0006 41.0564 19.2199 40.9656 19.4485 40.9656H22.8968C23.1254 40.9656 23.3447 41.0564 23.5063 41.2181C23.668 41.3797 23.7588 41.599 23.7588 41.8276C23.7588 42.0563 23.668 42.2756 23.5063 42.4372C23.3447 42.5989 23.1254 42.6897 22.8968 42.6897Z'
          fill='#48CAE4'
        />
        <path
          d='M22.8968 39.2415H19.4485C19.2199 39.2415 19.0006 39.1506 18.8389 38.989C18.6773 38.8273 18.5864 38.608 18.5864 38.3794C18.5864 38.1508 18.6773 37.9315 18.8389 37.7698C19.0006 37.6082 19.2199 37.5173 19.4485 37.5173H22.8968C23.1254 37.5173 23.3447 37.6082 23.5063 37.7698C23.668 37.9315 23.7588 38.1508 23.7588 38.3794C23.7588 38.608 23.668 38.8273 23.5063 38.989C23.3447 39.1506 23.1254 39.2415 22.8968 39.2415Z'
          fill='#ADE8F4'
        />
        <path
          d='M25.4829 28.0344H22.8967C22.6681 28.0344 22.4488 27.9436 22.2872 27.7819C22.1255 27.6203 22.0347 27.401 22.0347 27.1724C22.0347 26.9437 22.1255 26.7245 22.2872 26.5628C22.4488 26.4011 22.6681 26.3103 22.8967 26.3103H25.4829C25.7116 26.3103 25.9308 26.4011 26.0925 26.5628C26.2542 26.7245 26.345 26.9437 26.345 27.1724C26.345 27.401 26.2542 27.6203 26.0925 27.7819C25.9308 27.9436 25.7116 28.0344 25.4829 28.0344Z'
          fill='#ADE8F4'
        />
        <path
          d='M22.9657 39.2329C22.9435 39.2399 22.9201 39.2429 22.8968 39.2415H19.4485C19.2199 39.2415 19.0006 39.1506 18.8389 38.989C18.6773 38.8273 18.5864 38.608 18.5864 38.3794C18.5864 38.1508 18.6773 37.9315 18.8389 37.7698C19.0006 37.6082 19.2199 37.5173 19.4485 37.5173H22.3278C22.5115 38.0995 22.7244 38.6721 22.9657 39.2329Z'
          fill='#48CAE4'
        />
        <path
          d='M18.5862 46.1379H30.6552C31.3411 46.1379 31.9989 46.4104 32.4839 46.8954C32.9689 47.3804 33.2414 48.0382 33.2414 48.7241V58.2069H16V48.7241C16 48.0382 16.2725 47.3804 16.7575 46.8954C17.2425 46.4104 17.9003 46.1379 18.5862 46.1379Z'
          fill='#48CAE4'
        />
        <path
          d='M33.2414 54.7586V58.2069H16V48.7241C16 48.0382 16.2725 47.3804 16.7575 46.8954C17.2425 46.4104 17.9003 46.1379 18.5862 46.1379H19.4483C19.4483 48.4243 20.3565 50.617 21.9732 52.2337C23.5899 53.8504 25.7826 54.7586 28.069 54.7586H33.2414Z'
          fill='#00B4D8'
        />
        <path
          d='M28.931 51.3103H20.3103C20.0817 51.3103 19.8624 51.2195 19.7007 51.0578C19.5391 50.8962 19.4482 50.6769 19.4482 50.4483C19.4482 50.2196 19.5391 50.0003 19.7007 49.8387C19.8624 49.677 20.0817 49.5862 20.3103 49.5862H28.931C29.1596 49.5862 29.3789 49.677 29.5406 49.8387C29.7022 50.0003 29.7931 50.2196 29.7931 50.4483C29.7931 50.6769 29.7022 50.8962 29.5406 51.0578C29.3789 51.2195 29.1596 51.3103 28.931 51.3103Z'
          fill='#D0D8DA'
        />
        <path
          d='M28.9313 55.6206H19.4485C19.2199 55.6206 19.0006 55.5298 18.8389 55.3681C18.6773 55.2065 18.5864 54.9872 18.5864 54.7586C18.5864 54.5299 18.6773 54.3106 18.8389 54.149C19.0006 53.9873 19.2199 53.8965 19.4485 53.8965H28.9313C29.1599 53.8965 29.3792 53.9873 29.5408 54.149C29.7025 54.3106 29.7933 54.5299 29.7933 54.7586C29.7933 54.9872 29.7025 55.2065 29.5408 55.3681C29.3792 55.5298 29.1599 55.6206 28.9313 55.6206Z'
          fill='#D0D8DA'
        />
        <path
          d='M21.181 51.3104H20.3103C20.0817 51.3104 19.8624 51.2196 19.7007 51.0579C19.5391 50.8962 19.4482 50.677 19.4482 50.4483C19.4484 50.243 19.5226 50.0445 19.6572 49.8894C19.7917 49.7342 19.9777 49.6327 20.181 49.6035C20.4396 50.2131 20.7757 50.7868 21.181 51.3104Z'
          fill='#B8BEBF'
        />
        <path
          d='M29.7933 54.7586C29.7933 54.9872 29.7025 55.2065 29.5408 55.3681C29.3792 55.5298 29.1599 55.6206 28.9313 55.6206H19.4485C19.2199 55.6206 19.0006 55.5298 18.8389 55.3681C18.6773 55.2065 18.5864 54.9872 18.5864 54.7586C18.5864 54.5299 18.6773 54.3106 18.8389 54.149C19.0006 53.9873 19.2199 53.8965 19.4485 53.8965H24.3192C25.4872 54.4657 26.7698 54.7606 28.0692 54.7586H29.7933Z'
          fill='#B8BEBF'
        />
        <path
          d='M66.0001 40.9656V46.138H31.1639C30.5194 44.478 30.1047 42.7378 29.9312 40.9656H66.0001Z'
          fill='#ADE8F4'
        />
        <path
          d='M66.0001 43.5518V46.138H31.1639C30.5194 44.478 30.1047 42.7378 29.9312 40.9656H36.6898C36.6898 41.6515 36.9622 42.3093 37.4473 42.7943C37.9323 43.2793 38.5901 43.5518 39.276 43.5518H66.0001Z'
          fill='#48CAE4'
        />
        <path
          d='M36.6895 40.9656H29.9309C29.8397 40.1066 29.7936 39.2433 29.793 38.3794C29.793 38.0863 29.8016 37.8018 29.8102 37.5173H33.2412C34.1558 37.5173 35.0329 37.8806 35.6795 38.5273C36.3262 39.174 36.6895 40.0511 36.6895 40.9656Z'
          fill='#48CAE4'
        />
        <path
          d='M36.6895 40.9656H29.9309C29.8397 40.1066 29.7936 39.2433 29.793 38.3794C29.793 38.0863 29.8016 37.8018 29.8102 37.5173H31.5171C31.5185 37.9742 31.7006 38.4119 32.0236 38.735C32.3466 39.058 32.7844 39.2401 33.2412 39.2415H36.224C36.5283 39.7652 36.6889 40.3599 36.6895 40.9656Z'
          fill='#00B4D8'
        />
        <path d='M48.7588 49.5862H59.1036V54.7586H48.7588V49.5862Z' fill='#E9F1F2' />
        <path d='M48.7588 49.5862H53.9312V54.7586H48.7588V49.5862Z' fill='#D0D8DA' />
        <path
          d='M59.1034 49.5862H48.7586L46.1724 46.1379H60.8275L59.1034 49.5862Z'
          fill='#D0D8DA'
        />
        <path
          d='M61.6898 58.2068H47.0347L48.7588 54.7585H59.1036L61.6898 58.2068Z'
          fill='#D0D8DA'
        />
        <path d='M52.207 49.5862H55.6553V54.7586H52.207V49.5862Z' fill='#ADE8F4' />
        <path d='M47.0347 22H66.0002V35.7931H47.0347V22Z' fill='#ADE8F4' />
        <path d='M47.0347 22V35.7931H66.0002L52.2071 22H47.0347Z' fill='#48CAE4' />
        <path d='M53.9312 35.7932H59.1036V40.9656H53.9312V35.7932Z' fill='#D0D8DA' />
        <path
          d='M59.1036 35.7932V37.5174H58.2415C57.5556 37.5174 56.8978 37.7898 56.4128 38.2748C55.9278 38.7598 55.6553 39.4177 55.6553 40.1036V40.9656H53.9312V35.7932H59.1036Z'
          fill='#B8BEBF'
        />
        <path d='M50.4829 25.4482H53.9312V28.8965H50.4829V25.4482Z' fill='#EF5350' />
        <path
          d='M62.5516 26.3103H59.1033C58.8746 26.3103 58.6554 26.2195 58.4937 26.0578C58.332 25.8962 58.2412 25.6769 58.2412 25.4483C58.2412 25.2196 58.332 25.0003 58.4937 24.8387C58.6554 24.677 58.8746 24.5862 59.1033 24.5862H62.5516C62.7802 24.5862 62.9995 24.677 63.1611 24.8387C63.3228 25.0003 63.4136 25.2196 63.4136 25.4483C63.4136 25.6769 63.3228 25.8962 63.1611 26.0578C62.9995 26.2195 62.7802 26.3103 62.5516 26.3103Z'
          fill='#E9F1F2'
        />
        <path
          d='M63.4136 29.7586H57.3792C57.1505 29.7586 56.9313 29.6677 56.7696 29.5061C56.6079 29.3444 56.5171 29.1251 56.5171 28.8965C56.5171 28.6679 56.6079 28.4486 56.7696 28.2869C56.9313 28.1252 57.1505 28.0344 57.3792 28.0344H63.4136C63.6423 28.0344 63.8615 28.1252 64.0232 28.2869C64.1849 28.4486 64.2757 28.6679 64.2757 28.8965C64.2757 29.1251 64.1849 29.3444 64.0232 29.5061C63.8615 29.6677 63.6423 29.7586 63.4136 29.7586Z'
          fill='#E9F1F2'
        />
        <path
          d='M62.5515 33.2068H60.8274C60.5988 33.2068 60.3795 33.116 60.2178 32.9543C60.0562 32.7926 59.9653 32.5734 59.9653 32.3447C59.9653 32.1161 60.0562 31.8968 60.2178 31.7352C60.3795 31.5735 60.5988 31.4827 60.8274 31.4827H62.5515C62.7802 31.4827 62.9994 31.5735 63.1611 31.7352C63.3228 31.8968 63.4136 32.1161 63.4136 32.3447C63.4136 32.5734 63.3228 32.7926 63.1611 32.9543C62.9994 33.116 62.7802 33.2068 62.5515 33.2068Z'
          fill='#E9F1F2'
        />
        <path
          d='M53.931 33.2068H50.4827C50.254 33.2068 50.0348 33.116 49.8731 32.9543C49.7114 32.7926 49.6206 32.5734 49.6206 32.3447C49.6206 32.1161 49.7114 31.8968 49.8731 31.7352C50.0348 31.5735 50.254 31.4827 50.4827 31.4827H53.931C54.1596 31.4827 54.3789 31.5735 54.5405 31.7352C54.7022 31.8968 54.793 32.1161 54.793 32.3447C54.793 32.5734 54.7022 32.7926 54.5405 32.9543C54.3789 33.116 54.1596 33.2068 53.931 33.2068Z'
          fill='#D0D8DA'
        />
        <path
          d='M57.3792 33.2068C57.8553 33.2068 58.2412 32.8208 58.2412 32.3447C58.2412 31.8686 57.8553 31.4827 57.3792 31.4827C56.9031 31.4827 56.5171 31.8686 56.5171 32.3447C56.5171 32.8208 56.9031 33.2068 57.3792 33.2068Z'
          fill='#D0D8DA'
        />
        <path
          d='M59.9654 29.7586H57.3792C57.1505 29.7586 56.9313 29.6677 56.7696 29.5061C56.6079 29.3444 56.5171 29.1251 56.5171 28.8965C56.5171 28.6679 56.6079 28.4486 56.7696 28.2869C56.9313 28.1252 57.1505 28.0344 57.3792 28.0344H58.2412L59.9654 29.7586Z'
          fill='#D0D8DA'
        />
        <path
          d='M63.1636 32.9568C63.0002 33.1171 62.7804 33.2068 62.5515 33.2068H60.8274C60.5988 33.2068 60.3795 33.116 60.2178 32.9543C60.0562 32.7926 59.9653 32.5734 59.9653 32.3447C59.9653 32.1161 60.0562 31.8968 60.2178 31.7352C60.3795 31.5735 60.5988 31.4827 60.8274 31.4827H61.6895L63.1636 32.9568Z'
          fill='#D0D8DA'
        />
        <path
          d='M60.8275 46.1379L59.9655 47.8621H55.6551C55.1983 47.8634 54.7605 48.0455 54.4375 48.3686C54.1144 48.6916 53.9323 49.1294 53.931 49.5862H48.7586L46.1724 46.1379H60.8275Z'
          fill='#B8BEBF'
        />
        <path
          d='M61.6898 58.2068H47.0347L48.7588 54.7585H53.9312C53.9326 55.2154 54.1147 55.6531 54.4377 55.9762C54.7608 56.2992 55.1985 56.4813 55.6554 56.4827H60.3967L61.6898 58.2068Z'
          fill='#B8BEBF'
        />
        <path d='M52.207 49.5862H53.9312V54.7586H52.207V49.5862Z' fill='#48CAE4' />
      </g>
      <defs>
        <clipPath id='clip0_414_9518'>
          <rect width='50' height='50' fill='white' transform='translate(15.8569 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
RadiologyAndMedicalImagingIcon.displayName = 'RadiologyAndMedicalImagingIcon';

export default RadiologyAndMedicalImagingIcon;
